<template>
    <div class="items">
        <div class="nav">
          <div class="logo"><img src="/assets/images/logo-navbar.svg"></div>
            <div class="button-home" @click="goSpots"><img :src="'/assets/buttons/button-home.svg'"></div>
        </div>
        <div class="title-items">{{ itemsTitle }}</div>
        <div class="matrix-container">
          <div v-if="info" class="matrix-item" @click="showInfo">
            <img src="/assets/buttons/info.png">
            <div class="matrix-item-title">Introductie</div>
          </div>
            <div v-bind:key="objectItem.id" v-for="objectItem in objectItems" class="matrix-item" @click="showItem(objectItem.id)">
              <img :src="objectItem.image" alt="thumb">
              <div class="matrix-item-title" v-if="objectItem.label !== '999'">{{ objectItem.label }}</div>
            </div>
        </div>
    </div>
</template>

<script>
import router from '@/router';
import config from '@/config/config.json';
import axios from 'axios';

export default {
    name: 'Items',
    props: ['langId', 'spotId'],
    methods: {
        goLanguage() {
            router.push('/');
        },
        goSpots() {
            router.push('/spots/' + this.langId);
        },
        showItem(itemIn) {
            router.push('/item/' + this.spotId + '/' + itemIn + '/' + this.langId);
        },
      showInfo() {
        // console.log('info');
        router.push('/spotinfo/' + this.spotId + '/' + this.langId);
      }
    },
    data() {
        return {
            itemsTitle: '',
            info: false,
            kioskBackground: '#000000',
            configData: config,
            objectItems: [],
            objectsAmount: 0,
        }
    },
    created() {
        // Items (spot) title
        let axiosSpot = this.configData.api + 'item_sets/' + this.spotId + '@key_identity=' + this.configData.key_identity + '&@key_credential=' + this.configData.key_credential;
        // console.log('axiosspot query: ' + axiosSpot);
        axios.get(axiosSpot)
        .then((res) => {
            res.data["dcterms:title"].forEach((spotTitleFound) => {
                if(spotTitleFound["@language"] === this.langId) {
                    this.itemsTitle = spotTitleFound["@value"];
                }
            });
        })
        .catch((spotError) => {
            console.log('spotError (title): ' + spotError);
        });
        // get objects in spot
        let axiosObjects = this.configData.api + 'items?item_set_id=' + this.spotId + '&@key_identity=' + this.configData.key_identity + '&@key_credential=' + this.configData.key_credential;
        // console.log('axiosObjects url: ' + axiosObjects);
        axios.get(axiosObjects)
        .then((res) => {
            let objectItemsUnsorted = [];
            res.data.forEach((matrixObjectFound) => {
                let matrixItemToPush = {
                    "id": matrixObjectFound["o:id"],
                    "image": "",
                    "label": ""
                };
                if(matrixObjectFound.thumbnail_display_urls.square && matrixObjectFound.thumbnail_display_urls.square.slice(-4) !== '.jpg' && matrixObjectFound.thumbnail_display_urls.square.slice(-4) !== '.png'){
                    matrixItemToPush.image = '/assets/dummies/dummy_thumb.jpg';
                } else {
                    matrixItemToPush.image = matrixObjectFound.thumbnail_display_urls.square;
                }
                if(matrixObjectFound["dcterms:alternative"] && matrixObjectFound["dcterms:alternative"][0]) {
                    matrixItemToPush.label = matrixObjectFound["dcterms:alternative"][0]["@value"];
                }
                objectItemsUnsorted.push(matrixItemToPush);
            });
            // sort objectItems with label
            let firstObject = 'Intro';
            this.objectItems = objectItemsUnsorted.sort((a, b) => {
                if(a.label === '') {
                    a.label = '999';
                }
                if(b.label === '') {
                    b.label = '999';
                }
                if(a.label === 'Intro') {
                    a.label = '0';
                }
                if(b.label === 'Intro') {
                    b.label = '0';
                }
                return parseInt(a.label) - parseInt(b.label);
            });
            // put Intro first
            this.objectItems[0].label = firstObject;
        })
        .catch((itemsError) => {
            console.log('itemsError: ' + itemsError);
        });
    }
}
</script>

<style>
.items {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    min-height: 100%;
    color: white;
}
.title-items {
    position: absolute;
    left: 5%;
    top: 70px;
    font-size: 1.5em;
    /*color: black;*/
}
.matrix-container {
    position: relative;
    margin-top: 100px;
    margin-left: auto;
    margin-right: auto;
    padding-bottom: 20px;
    /* margin-bottom: 100px; */
    width: 90%;
    /*height: 450px;*/
    display: flex;
    flex-wrap: wrap;
    /* background-color: white; */
    align-items: center;
    align-content: flex-start;
}

.matrix-item {
    position: relative;
    display: inline-flex;
    width: 31.333%;
    height: 110px;
    margin: 1%;
    background-color: #00000099;
}
.matrix-item img {
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.matrix-item-title {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 98%;
  font-family: EtelkaMedium, sans-serif;
  color: white;
  /*background-color: #FFFFFF66;*/
  background-color: #67808A66;
  font-size: 14px;
  padding-left: 2%;
  padding-bottom: 2px;
  padding-top: 2px;
}
@media only screen and (min-width: 768px) {
    .matrix-item {
        position: relative;
        display: inline-flex;
        width: 23%;
        height: 150px;
        margin: 1%;
        background-color: #00000099;
    }
    .matrix-item img {
        position: absolute;
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
    .matrix-item-title {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 98%;
        font-family: EtelkaMedium, sans-serif;
        color: white;
        /*background-color: #FFFFFF66;*/
        background-color: #67808A66;
        font-size: 14px;
        padding-left: 2%;
        padding-bottom: 2px;
        padding-top: 2px;
    }
}
@media only screen and (min-width: 1280px) {
    .matrix-item {
        position: relative;
        display: inline-flex;
        width: 18%;
        height: 180px;
        margin: 1%;
        background-color: #00000099;
    }
    .matrix-item img {
        position: absolute;
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
    .matrix-item-title {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 98%;
        font-family: EtelkaMedium, sans-serif;
        color: white;
        /*background-color: #FFFFFF66;*/
        background-color: #67808A66;
        font-size: 14px;
        padding-left: 2%;
        padding-bottom: 2px;
        padding-top: 2px;
    }
}
</style>
